/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Simulator from './Components/Simulator.vue';
import Vue from 'vue';
import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';
import AOS from 'aos';

import 'aos/dist/aos.css'; // You can also use <link> for styles
$(document).ready(() => {
  $('.spinner-overlay').addClass('loaded');

  $('#toggle-menu').click(() => {
    $('.mobile-menu').toggleClass('open');
  });

  var bodyPadded = false;
  var lastHeaderHeight = 0;
  $(document).scroll(function() {
    var scroll = $(this).scrollTop();
    var navbarHeight = document.querySelector('.navbar').clientHeight;
    var menuHeight = document.querySelector('.navbar .menu-container')
      .clientHeight;
    var headerHeight = navbarHeight - menuHeight;

    if (scroll > headerHeight) {
      if (!bodyPadded) {
        lastHeaderHeight = headerHeight;

        $('body').addClass('fixed-navbar');
        bodyPadded = true;
      }
    }

    if (scroll <= lastHeaderHeight) {
      $('body').removeClass('fixed-navbar');
      if (bodyPadded) {
        $('body').removeClass('fixed-navbar');
        bodyPadded = false;
      }
    }
  });

  const simulatorMountElements = [
    ...document.querySelectorAll('.simulator-app'),
  ];

  simulatorMountElements.forEach(simulatorMountElement => {
    const app = new Vue({
      render: h => h(Simulator),
    }).$mount(simulatorMountElement);
  });

  $('.testimonial-slider').each(function(index, sliderElement) {
    var flkty = new Flickity(sliderElement, {
      // options
      cellAlign: 'left',
      contain: true,
      groupCells: true,
    });
  });

  $('.progression-list').each(function(index, element) {});

  if (!!window.IntersectionObserver) {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            $(entry.target).addClass('focus');
          } else {
            $(entry.target).removeClass('focus');
          }
        });
      },
      { rootMargin: '0px 0px -50% 0px' }
    );

    document.querySelectorAll('.progression-list .etape').forEach(etape => {
      observer.observe(etape);
    });
  }

  $('.accordeon-section-title').click(function() {
    $(this)
      .parent()
      .toggleClass('open');

    $(this)
      .next('.accordeon-section-content')
      .toggle('animate');
  });

  $('.be-called-back  .close').click(e => {
    e.preventDefault();
    $('.be-called-back').removeClass('is-active');
  });
  $('.be-called-back .modal-background, .modal-close').click(() => {
    $('.be-called-back').removeClass('is-active');
  });

  $('a[href=#be-called-back]').click(e => {
    e.preventDefault();
    $('.be-called-back').addClass('is-active');
  });

  const forms = document.querySelectorAll('.wpcf7-form');

  for (let i = 0; i < forms.length; i++) {
    const form = forms[i];

    const steps = form.querySelectorAll('.etape');
    const submitButton = form.querySelector('*[type=submit]');

    submitButton.removeAttribute('type');
    submitButton.classList.add('button');
    submitButton.classList.add('is-primary');

    const buttonLabel = submitButton.innerHTML;

    form.parentElement.addEventListener(
      'wpcf7submit',
      function(event) {
        submitButton.classList.remove('is-loading');
        submitButton.removeAttribute('disabled');
      },
      false
    );

    form.addEventListener('submit', e => {
      submitButton.classList.add('is-loading');
      submitButton.setAttribute('disabled', 'disabled');
    });

    for (let j = 0; j < steps.length; j++) {
      const step = steps[j];

      const inputs = Array.from(
        step.querySelectorAll('input, select, textarea')
      );

      const nextButton = step.querySelector('.next-step');
      const previousButton = step.querySelector('.previous-step');

      for (let k = 0; k < inputs.length; k++) {
        const input = inputs[k];
        input.addEventListener('input', () => {
          let notComplete = false;
          for (let l = 0; l < inputs.length; l++) {
            const input = inputs[l];

            if (!input.value) {
              notComplete = true;
            }
          }

          if (nextButton) {
            if (notComplete) {
              console.log('not completed');
              nextButton.setAttribute('disabled', 'disabled');
            } else {
              console.log('completed');
              nextButton.removeAttribute('disabled');
            }
          }
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', e => {
          e.preventDefault();
          step.classList.remove('active');
          steps[j + 1].classList.add('active');
        });
      }
      if (previousButton) {
        previousButton.addEventListener('click', e => {
          e.preventDefault();
          step.classList.remove('active');

          steps[j - 1].classList.add('active');
        });
      }
    }
  }

  AOS.init({
    once: true,
    disable: 'mobile',
  });

  const ratesElements = document.querySelectorAll('.rate-boxes .rate');

  for (let i = 0; i < ratesElements.length; i++) {
    const ratesElement = ratesElements[i];

    const rate = ratesElement.getAttribute('data-rate');
    let incRate = 0;
    ratesElement.innerHTML = `0%`;
    const interval = setInterval(() => {
      incRate += 0.01;
      ratesElement.innerHTML = `${incRate.toFixed(2)}%`;
      if (incRate >= rate) {
        clearInterval(interval);
        ratesElement.classList.add('scale');
      }
    }, 20);
  }
});

(function($) {
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: 'administrative',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#444444',
            },
          ],
        },
        {
          featureType: 'administrative.neighborhood',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'on',
            },
            {
              color: '#f35c19',
            },
            {
              weight: '0.01',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              color: '#f2f2f2',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'on',
            },
            {
              color: '#f7e5d9',
            },
            {
              lightness: '0',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'labels.text',
          stylers: [
            {
              weight: '0.64',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'on',
            },
            {
              weight: '1',
            },
            {
              lightness: '63',
            },
            {
              color: '#fff5f0',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [
            {
              color: '#ffad00',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffc3a0',
            },
            {
              lightness: '1',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 45,
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'on',
            },
            {
              color: '#fd7539',
            },
            {
              weight: '0.62',
            },
            {
              lightness: '53',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'on',
            },
            {
              color: '#4e5757',
            },
            {
              weight: '0.01',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              weight: '0.01',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#ffffff',
            },
            {
              visibility: 'on',
            },
            {
              weight: '0.01',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            {
              color: '#c6e3ec',
            },
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'on',
            },
            {
              color: '#E1C9C3',
            },
            {
              lightness: '-3',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              weight: '0.25',
            },
            {
              color: '#E1C9C3',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              weight: '0.80',
            },
          ],
        },
      ],
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function() {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: '/app/themes/perfectaux/dist/images/marker.png',
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function(marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function() {
    $('.acf-map').each(function() {
      var map = initMap($(this));
    });
  });
})(jQuery);
